import { MapPin, MessageCircle, Star } from "lucide-react";
import { business, waLink } from "../config/business";
import { useLanguage } from "../i18n/LanguageContext";
import { Chapter, Reveal } from "./shared";

const Coverage = () => {
  const { t } = useLanguage();

  return (
    <section id="areas" data-testid="coverage-section" className="section-alt">
      <div className="relative mx-auto max-w-6xl px-5 sm:px-8 py-20 sm:py-28">
        <Chapter title={t.coverage.title} sub={t.coverage.sub} />

        <div className="grid gap-6 lg:grid-cols-5 lg:gap-8">
          <Reveal className="lg:col-span-2">
            <div
              data-testid="coverage-main-area"
              className="card-elevated relative flex h-full flex-col justify-between overflow-hidden rounded-3xl border-amber-500/30 p-7 sm:p-8"
            >
              <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-amber-400/15 blur-3xl" />
              <span className="inline-flex items-center gap-2 self-start rounded-full border border-amber-400/30 bg-amber-400/10 px-3 py-1.5 font-mono text-[11px] uppercase tracking-widest text-amber-300">
                <Star className="h-3.5 w-3.5 fill-current" />
                {t.coverage.main}
              </span>
              <div className="mt-8 flex items-center gap-4">
                <span className="icon-tile flex h-14 w-14 items-center justify-center rounded-2xl text-amber-400">
                  <MapPin className="h-7 w-7" strokeWidth={2} />
                </span>
                <span className="font-heading text-3xl sm:text-4xl font-bold tracking-[-0.03em]">{business.mainArea}</span>
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-3">
            <Reveal delay={0.1}>
              <p className="mb-4 font-mono text-xs uppercase tracking-widest text-slate-500">{t.coverage.additional}</p>
            </Reveal>
            <div data-testid="coverage-city-list" className="grid gap-4 sm:grid-cols-2">
              {business.coverage.map((city, i) => (
                <Reveal key={city} delay={0.1 + i * 0.06}>
                  <div className="card-elevated card-lift group flex items-center gap-3 rounded-2xl px-6 py-5">
                    <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/[0.05] text-slate-300 transition-colors duration-300 group-hover:bg-amber-500/10 group-hover:text-amber-400">
                      <MapPin className="h-4 w-4" />
                    </span>
                    <span className="font-heading text-base font-semibold tracking-[-0.01em]">{city}</span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>

        <Reveal delay={0.3} className="mt-12">
          <div
            data-testid="coverage-eta-checker"
            className="relative flex flex-col items-start gap-5 overflow-hidden rounded-3xl border border-amber-500/20 bg-gradient-to-br from-amber-500/10 via-[var(--bg-card)] to-[var(--bg-card)] p-7 sm:p-8 shadow-[inset_0_1px_0_rgba(255,255,255,0.08),0_24px_50px_-20px_rgba(0,0,0,0.6)] sm:flex-row sm:items-center sm:justify-between"
          >
            <p className="relative text-base sm:text-lg text-slate-200">{t.coverage.cta}</p>
            <a
              data-testid="coverage-whatsapp-button"
              href={waLink(t.hero.waMessage)}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-wa relative shrink-0 rounded-full px-7 py-3.5 text-sm"
            >
              <MessageCircle className="h-4 w-4" strokeWidth={2.5} />
              {t.coverage.ctaBtn}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Coverage;
